import { Chip } from "@/components/control-tower/Chip";
import type { Equipment } from "@/lib/api/building";

// Single-select device scope for the Energiatehokkuus building view. Optimointi is
// device-driven — a Recipe always targets exactly one equipment item (`Recipe.equipment_id`,
// singular — docs/spec/concepts.md → "Recipe source and target") — so a device is always
// selected here, never "kaikki": OptimizationBuildingSection falls back to the first
// optimization-capable item when nothing's picked yet. Zone is a data source the selected
// device's Tilojen tarve panel reads (OperationalLoopSection), not a second filter dimension.
export function EquipmentFilter({
  equipment,
  active,
  onChange,
}: {
  equipment: Equipment[];
  active: string;
  onChange: (equipmentId: string) => void;
}) {
  if (equipment.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-1">
      {equipment.map((e) => (
        <Chip
          key={e.id}
          active={active === e.id}
          label={e.name}
          onClick={() => onChange(e.id)}
        />
      ))}
    </div>
  );
}
